import Popup from '@components/popup.vue'
import Vue from 'vue'

const PopupConstructor = Vue.extend(Popup)

const popup = (msg) => {
  return new Promise((resolve, reject) => {
    var existedPopupEl = document.getElementById('popup-container')
    if (existedPopupEl) {
      document.body.removeChild(existedPopupEl)
    }
    const popupDom = new PopupConstructor({
      el: document.createElement('div'),
    })
    document.body.appendChild(popupDom.$el)
    popupDom.msg = msg
    if (!msg.position && msg.position !== 0) {
      msg.position = 'middle'
    }
    if (!msg.btn) {
      msg.btn = {
        cancel: '',
        apply: '',
        confirm: 'OK',
      }
    }
    if (!msg.btnStyle) {
      msg.btnStyle = {
        panel: {},
        cancel: {},
        apply: {},
        confirm: {},
      }
    }
    popupDom.cancel = (res) => {
      reject(res)
      if (msg.cancel) {
        msg.cancel()
      }
      popupDom.showPopup = false
    }
    popupDom.apply = (res) => {
      resolve(res)
      if (msg.apply) {
        msg.apply()
      }
      popupDom.showPopup = false
    }
    popupDom.confirm = (res) => {
      resolve(res)
      if (msg.confirm) {
        msg.confirm()
      }
      if (!msg.noCloseFlag) {
      popupDom.showPopup = false
      }
      if(msg.url){
        if (
            (msg.url.indexOf('search-result') > 0 ||
            msg.url.indexOf('brand-facility') > 0 ||
            msg.url.indexOf('newend-facility') > 0 ||
            msg.url.indexOf('searchTag-facility') > 0 ||
            msg.url === '/') && msg.loginurl !== ""
          ) {
          event.preventDefault()
          location.href = msg.loginurl
        }
      }

    }
  })
}
export default popup
